/**
 * Decide whether closing the multi-select popover should persist the selection.
 *
 * Editing an already-**confirmed** value: only write when the selection actually
 * changed, to avoid inserting a redundant identical user_data row.
 *
 * Confirming a **pending / empty** value (`commitEvenIfUnchanged`): writing is the
 * whole point — the value isn't in user_data yet. Without this, opening a
 * pre-filled pending multi-select (e.g. the extractor's `Tile,Parquet`) and
 * clicking Done *without toggling anything* matched the initial key and silently
 * saved nothing, leaving the field stuck "pending" forever (WHA-3643 follow-up).
 *
 * An empty selection that never changed is treated as a cancel so we don't write
 * a junk empty row when a user opens an empty field and closes it untouched.
 */
export function shouldCommitMultiSelect(params: {
  currentKey: string;
  initialKey: string;
  commitEvenIfUnchanged: boolean;
  hasSelection: boolean;
}): boolean {
  const { currentKey, initialKey, commitEvenIfUnchanged, hasSelection } = params;
  const changed = currentKey !== initialKey;
  return changed || (commitEvenIfUnchanged && hasSelection);
}
